/**
 * Криптослучайный пароль: 16 символов из алфавита без визуально похожих
 * (нет 0/O, 1/l/I). crypto.getRandomValues — не Math.random.
 */
export function generatePassword(length = 16): string {
  const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$%^&*-_=+';
  const values = new Uint32Array(length);
  crypto.getRandomValues(values);
  return [...values].map((v) => alphabet[v % alphabet.length]).join('');
}
